<template>
    <div :class="$style.wrapper">
        <h1 class="crumb" style="border: 0">设置职位</h1>
        <div style="display: flex; height: 100%;">
            <!-- <div :class="$style.sider">
                <div v-for="({name, isEdit,position_id,position_name}, index) in positionList" :key="index">
                    <div v-show="isEdit" :class="$style.sider_menu">
                        <el-input ref="editInput" v-model="position_name" @blur="handelEditBlur(index, position_name)"
                                  :autofocus="true"></el-input>
                    </div>
                    <div v-show="!isEdit" :class="$style.sider_menu">
                        <span>{{position_name}}</span>
                        <EditPopover :handleDel="handleDel" :handleEdit="handleEditFocus.bind(this, index)"><a>编辑</a>
                        </EditPopover>
                    </div>
                </div>

                <div v-show="showNew" :class="$style.sider_menu">
                    <el-input ref="addInput" v-model="newPosition" @blur="handelAddBlur" :autofocus="true"></el-input>
                </div>
                <span @click="handleAddFocus" :class="$style.sider_add">
                    <i class="el-icon-circle-plus-outline"/>添加新职位
                </span>
            </div> -->
            <div :class="$style.boxLeft">
                 <div :class="index===nowIndex ? $style.activest : $style.uls"  v-for="(item,index) in positionList" @click="getpermList(item,index)" >
                     <span v-show="item.xu">{{item.position_name}}</span>
                     <input v-show="!item.xu" v-model="item.position_name" ref="editInput"></input>
                     <div v-show="!isEdit" :class="$style.sider_menut">
                        <span>{{position_name}}</span>
                        <EditPopover :handleDel="handleDel.bind(this, item)" :handleEdit="handleEditFocus.bind(this, index,item)"><a style="font-size:15px">编辑</a>
                        </EditPopover>
                    </div>
                 </div>
                <input v-show="adds" style="width:260px;height:50px;padding-left:20px;font-size:0.15rem;border:none;outline:none;background:#dedede" v-model="newPosition" @blur="handelAddBlur" ></input>
               <div @click="handleAddFocus" :class="$style.sider_adds">
                    <i class="el-icon-circle-plus-outline"/>添加新职位
                </div>
            </div>
            <!-- 修改 -->
            <div class="boxt">
                <el-dialog title="修改职位" :visible.sync="dialogVisible">
                    <div class="bosform">
                        <el-form :model="formList" size="small" label-width="80px" label-position="right">
                            <el-form-item label="职位：">
                                <el-input v-model='formList.position_name'></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="yx-popover-btnGroup">
                        <el-button :loading="btnLoading" :class="['orangeBtn', 'yx-popover-btn']"  @click="medfa()">确定</el-button>
                        <el-button :class="['btn', 'yx-popover-btn', 'yx-popover-cancelBtn']" @click="dialogVisible=false">取消</el-button>
                    </div>

                </el-dialog>
            </div>
            <div :class="$style.content">
                <h3>经销商权限设置</h3>
                <div>
                    <el-checkbox-group v-model="checkList"  @change="chebox(checkList)">
                        <!-- <el-checkbox label="OrderList">订单列表</el-checkbox>
                        <el-checkbox label="Brokerage">佣金明细</el-checkbox>
                        <el-checkbox label="Report">订单报表</el-checkbox>
                        <el-checkbox label="Management">员工管理</el-checkbox>
                        <el-checkbox label="SupplyChain">批发市场</el-checkbox>
                        <el-checkbox label="Charge">收费标准</el-checkbox> -->
                     <el-checkbox v-for="item in checkLists" :label="item.position_value" :key="item.position_value">{{item.position_name}}</el-checkbox>
                  </el-checkbox-group>
                </div>

                <h3>订单列表权限设置</h3>
                <div>
                    <el-checkbox-group v-model="orderAuth" @change="cheorderAuth(orderAuth)">
                        <el-checkbox v-for="item in orderAuths" :label="item.position_value" :key="item.position_value">{{item.position_name}}</el-checkbox>
                      </el-checkbox-group>
                </div>

                <h3>订单来源权限设置</h3>
                <div>
                    <el-checkbox-group v-model="orderFrom" @change="cheorderFrom(orderFrom)">
                        <el-checkbox v-for="item in orderFroms" :label="item.position_value" :key="item.position_value">{{item.position_name}}</el-checkbox>
                      </el-checkbox-group>
                </div>

                <h3>查看个人或经销商权限设置</h3>
                <div>
                    <!-- <el-checkbox-group v-model="orderShow" @change="cheorderShow(orderShow)">
                        <el-checkbox v-for="item in orderShows" :label="item.value" :key="item.value">{{item.name}}</el-checkbox>
                      </el-checkbox-group> -->
                      <el-radio v-model="orderShow" v-for="item in orderShows" :label="item.value" :key="item.value" @change="cheorderShow(orderShow)">{{item.name}}</el-radio>
                </div>

                <!-- <div :class="$style.content_authList">
                    <div :class="$style.content_authList_item">
                        <span :class="$style.content_authList_item_icon"><i class="el-icon-check"/></span>
                        <span>订单列表</span>
                    </div>
                    <div :class="$style.content_authList_item">
                        <span :class="$style.content_authList_item_icon"><i class="el-icon-check"/></span>
                        <span>订单列表</span>
                    </div>
                    <div :class="$style.content_authList_item">
                        <span :class="$style.content_authList_item_icon"><i class="el-icon-check"/></span>
                        <span>订单列表</span>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    import { session_id } from '../stores/api';
    import Vue from 'vue';
    import EditPopover from '../components/SetPosition/EditPopover.vue';


    Vue.component('EditPopover', EditPopover);

    function str(a){
        var arr=JSON.stringify(a);
        var arrt= arr.replace(/\[|]/g,'')
        return arrt.replace(/\"/g,'')
    }
    export default {
        data () {
            return {
                xu:true,
                checkList:[],
                checkLists:[],
                position_id:'',//修改权限要传的id
                name:'',//修改权限要传的name
                xugelist:[],
                nowIndex:-1,
                showNew: false,
                dialogVisible:false,
                adds:false,
                formList:[],
                orderAuths:[],
                orderAuth:[],
                orderShows:[],
                orderShow:'',
                orderFroms:[],
                orderFrom:[],
                position_value:null,
                order_auth:null,
                order_show:null,
                order_from:null,
                newPosition: '',
                positionList: [{
                    name: '经销商',
                    isEdit: false,
                }, {
                    name: '管理员',
                    isEdit: false,
                }, {
                    name: '组长',
                    isEdit: false,
                }],
            };
        },
        methods: {
            handelEditBlur (index, name) {
                this.positionList[index].isEdit = false;
                this.positionList[index].name = name;
            },
            //新增
            handleAddFocus () {
                // this.showNew = true;
                // setTimeout(() => {
                //     this.$refs.addInput.focus();
                // }, 200);
                this.newPosition = '';
                this.adds=!this.adds;

            },
            //提交新增请求
            handelAddBlur () {
                // if (this.newPosition) {
                //     this.positionList.push(this.newPosition);
                //     this.newPosition = '';
                // }
                // this.showNew = false;
                this.$http.get(this.$reqUrl+'user.php?act=update_staff_position&session_id='+session_id+'&position_value='+''+'&position_name='+this.newPosition+'&sort='+'')
                .then(res=>{
                    console.log(res)
                    this.adds=!this.adds;
                    this.getList();
                })
            },
            //删除
            handleDel (item) {
                this.$http.get(this.$reqUrl+"user.php?act=drop_staff_position&session_id="+session_id+'&position_id='+item.position_id)
                .then(res=>{
                    this.checkList=[];
                    this.orderAuth=[];
                    this.orderShow=[];
                    this.orderFrom=[];
                    this.position_id='';
                    this.nowIndex=-1;
                    this.getList();
                })

            },
            //显示修改框
            handleEditFocus (index,item) {
                // this.positionList[index].isEdit = true;
                // setTimeout(() => {
                //     if (this.$refs.editInput) {
                //         this.$refs.editInput[index].focus();
                //     }
                // }, 200);
                // console.log(item.xu)
                // this.positionList[index].xu=false;
                this.dialogVisible=true;
                this.formList=item;
            },
            //确定修改
            medfa(){
                this.$http.get(this.$reqUrl+'user.php?act=update_staff_position&session_id='+session_id+'&position_value='+this.formList.position_value+'&position_name='+this.formList.position_name+'&sort='+''+'&position_id='+this.formList.position_id)
                .then(res=>{
                    console.log(res)
                    this.dialogVisible=false;
                    this.getList();
                })
            },
            //获取职位列表&权限内容
            getList(){
                this.$http.get(this.$reqUrl+'user.php?act=get_staff_position_list&content='+2+'&session_id='+session_id)
                .then(res=>{
                    console.log(res);
                    this.positionList=res.data.position_nav;
                    // for(let i=0;i<res.data.position_nav.length;i++){
                    //     this.positionList[i].xu=true;
                    // };
                    this.checkLists=res.data.position_nav[0].son;
                    console.log(this.checkLists)
                    this.orderAuths=res.data.orderAuth;
                    this.orderFroms=res.data.orderFrom;
                    this.orderShows=res.data.orderShow;
                })
            },
            //显示右边权限
            getpermList(item,index){
                console.log(item)
                this.checkList=item.position_value.split(",");
                this.orderAuth=item.order_auth.split(",");
                this.orderFrom=item.order_from.split(",");
                this.orderShow=item.order_show;
                this.position_id=item.position_id;
                this.name=item.position_name;
                this.nowIndex=index;
                console.log(this.orderShow)
            },
            //选择权限
            chebox(checkList){
                console.log(checkList)
                if(this.position_id==''){
                    this.$message.error('请选择职位');
                    this.checkList=[];
                    return false;
                }
                let data={
                    session_id:session_id,
                    position_value:str(checkList),
                    order_auth:str(this.orderAuth),
                    order_show:str(this.orderShow),
                    order_from:str(this.orderFrom),
                    position_name:this.name,
                    sort:'',
                    position_id:this.position_id
                }
                this.$http.get(this.$reqUrl+'user.php?act=update_staff_position',{params:data})
                .then(res=>{
                    console.log(res)
                     this.getList()
                })
            },
            cheorderAuth(orderAuth){
                if(this.position_id==''){
                    this.$message.error('请选择职位');
                    this.orderAuth=[];
                    return false;
                }
                let data={
                    session_id:session_id,
                    position_value:str(this.checkList),
                    order_auth:str(orderAuth),
                    order_show:str(this.orderShow),
                    order_from:str(this.orderFrom),
                    position_name:this.name,
                    sort:'',
                    position_id:this.position_id
                }
                this.$http.get(this.$reqUrl+'user.php?act=update_staff_position',{params:data})
                .then(res=>{
                    console.log(res)
                     this.getList()
                })
            },
            cheorderFrom(orderFrom){
                console.log(orderFrom)
                if(this.position_id==''){
                    this.$message.error('请选择职位');
                    this.orderFrom=[];
                    return false;
                }
                let data={
                    session_id:session_id,
                    position_value:str(this.checkList),
                    order_auth:str(this.orderAuth),
                    order_show:str(this.orderShow),
                    order_from:str(orderFrom),
                    position_name:this.name,
                    sort:'',
                    position_id:this.position_id
                }
                this.$http.get(this.$reqUrl+'user.php?act=update_staff_position',{params:data})
                .then(res=>{
                    console.log(res)
                     this.getList()
                })
            },
            cheorderShow(orderShow){
                console.log(orderShow)
                if(this.position_id==''){
                    this.$message.error('请选择职位');
                    this.orderShow=[];
                    return false;
                }
                let data={
                    session_id:session_id,
                    position_value:str(this.checkList),
                    order_auth:str(this.orderAuth),
                    order_show:str(orderShow),
                    order_from:str(this.orderFrom),
                    position_name:this.name,
                    sort:'',
                    position_id:this.position_id
                }

                this.$http.get(this.$reqUrl+'user.php?act=update_staff_position',{params:data})
                .then(res=>{
                    console.log(res)
                     this.getList()
                })
            }
        },
        mounted(){
            this.getList();
        }
    };
</script>

<style lang="less" module>
    .wrapper {
        height: 714Px;
        .sider {
            margin-right: 16px;
            height: 90%;
            text-align: center;
            background: #ffffff;
            border: 2px solid #d8dde6;
            .sider_menu {
                display: flex;
                justify-content: space-between;
                width: 250Px;
                padding: 16px 30px;
                border-bottom: 1px solid #d8dde6;
                cursor: pointer;
                a {
                    font-size: 14px;
                }
                input {
                    padding: 0;
                    margin: 0;
                    height: 100%;
                    font-size: 16px;
                    border: 0;
                    border-radius: 0;
                }
                &:hover, &:focus, &:active {
                    .sider_menu_active;
                }
            }
            .sider_menu_active {
                background: #edeff0;
                span {
                    color: #f56c31;
                }
                input {
                    background: #edeff0;
                }
            }
            .sider_add {
                display: inline-block;
                padding: 16px 0;
                font-size: 14px;
                color: #f56c31;
                cursor: pointer;
                i {
                    margin-right: 5px;
                }
            }
        }
        .content {
            flex: 1;
            height: 90%;
            padding: 0 30px;
            background: #ffffff;
            border: 2px solid #d8dde6;
            .content_authList {
                display: flex;
                flex-wrap: wrap;
                .content_authList_item {
                    margin-right: 30px;
                    .content_authList_item_icon {
                        display: inline-block;
                        width: 16Px;
                        height: 16Px;
                        margin-right: 8px;
                        border-radius: 2px;
                        /* border: 1px solid #C5C3C3; */
                        background: #09bb07;
                        vertical-align: text-bottom;
                        cursor: pointer;
                        i {
                            color: #FFF;
                        }
                    }
                    .active {
                        .content_authList_item_icon;
                        border: 1px solid #C5C3C3;
                        background: #FFF;
                        i {
                            color: #FFF;
                        }
                    }
                }
            }
        }
    }
.boxLeft{
    min-width:280px;
    margin-right: 16px;
    height: 90%;
    background: #ffffff;
    border: 2px solid #d8dde6;
}
.uls{
    width:280px;
    height:50px;
    line-height: 50px;
    font-size: 0.15rem;
    color: #1f2329;
    border-bottom:1px solid #d8dde6;
    margin-top:0;
}
.uls :hover,.activest :hover{
    cursor:pointer;
}
.uls span,.activest span{
    float:left;
    margin-left:20px;
}
.uls input,.activest input{
    margin-left:20px;
    float:left;
    display:inline-block;
    border:none;
    outline: none;
    background:none;
    // font-size: 0.15rem;
    height:50px;
}
.sider_menut{
    float:right;
}
.menut{
    flot:left;
    display:inline-block;
    border:none;
    outline:none;
    width:270px;
    height:50px;
}
.sider_adds{
    clear:both;
    padding: 0.13333rem 0;
    font-size: 0.11667rem;
    color: #f56c31;
    cursor: pointer;
    text-align:center;
}
.activest{
    background: #dedede;
    width:280px;
    height:50px;
    line-height: 50px;
    font-size: 0.15rem;
    color: #1f2329;
    border-bottom:1px solid #dedede;
    margin-top:0;
}
</style>
<style>
.el-dialog{
    width: 500px;
    margin: 0 auto 50px;
}
.bosform{
    padding: 30Px 90Px 30Px 70Px;
}
.bosform .el-input{
    width: 260px;
    height: 32px;
}
.el-dialog__body{
    padding:0;
}
.boxt .el-form-item--mini.el-form-item, .boxt .el-form-item--small.el-form-item{
    margin-bottom: 18px;
}
.boxt .el-form-item__content{
    margin-left:80px;
}
.el-dialog__body {
    padding-bottom: 30Px ;
    text-align: center;
}
.el-dialog__body input{
    border-radius: 0;
}
.yx-popover-btn {
    margin-top: 10PX;
    width:120Px;
    height:35Px;
    font-size:16px;
    color:#ffffff;
    border-radius:4px;
}
.yx-popover-cancelBtn {
    margin-left: 10px;
    background:#d8dde6;
}
</style>



// WEBPACK FOOTER //
// src/router/SetPosition.vue